import { render, staticRenderFns } from "./Annales.vue?vue&type=template&id=2b3b736c&scoped=true&"
import script from "./Annales.vue?vue&type=script&lang=js&"
export * from "./Annales.vue?vue&type=script&lang=js&"
import style0 from "./Annales.vue?vue&type=style&index=0&id=2b3b736c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b736c",
  null
  
)

export default component.exports